module.exports = {

  Actions: {
    next: 'Continue',
    Congratulations: 'Thank You!'
  },

  Validation: {
    genericError: 'Field value is not valid'
  }
}
